export interface TestSuiteOverview {
  summary?: boolean;
  vision?: boolean;
  lazyeye?: boolean;
  neurology?: boolean;
  concussion?: boolean;
}

export type OverviewCategory = keyof TestSuiteOverview;

export const OVERVIEW_CATEGORIES: OverviewCategory[] = [
  "summary",
  "vision",
  "lazyeye",
  "neurology",
  "concussion",
];

export const OVERVIEW_CATEGORY_LABEL_KEYS: Record<OverviewCategory, string> = {
  summary: "TestController.overviewCategorySummary",
  vision: "TestController.overviewCategoryVision",
  lazyeye: "TestController.overviewCategoryLazyEye",
  neurology: "TestController.overviewCategoryNeurology",
  concussion: "TestController.overviewCategoryConcussion",
};

export interface OverviewEligibility {
  eligible: boolean;
  reasonKey?: string;
}

export function getOverviewEligibility(
  _tests: { configuration: unknown }[] | null | undefined,
): OverviewEligibility {
  return { eligible: true };
}

export function getSelectedOverviewCategories(
  overview?: TestSuiteOverview | null,
): OverviewCategory[] {
  if (!overview) return [];
  return OVERVIEW_CATEGORIES.filter((category) => overview[category]);
}

export function getOverviewPayload(
  enabled: boolean,
  selectedCategories: OverviewCategory[],
  existingOverview?: TestSuiteOverview | null,
): TestSuiteOverview {
  const selected = new Set(enabled ? selectedCategories : []);
  return {
    ...existingOverview,
    summary: selected.has("summary"),
    vision: selected.has("vision"),
    lazyeye: selected.has("lazyeye"),
    neurology: selected.has("neurology"),
    concussion: selected.has("concussion"),
  };
}

export function isOverviewEnabled(overview?: TestSuiteOverview | null): boolean {
  return !!overview && Object.values(overview).some(Boolean);
}
